import {createFileRoute} from '@tanstack/react-router';
import {LoginConsentsPage} from 'pages/login/LoginConsentsPage';

export const Route = createFileRoute('/login/consents')({
  component: LoginConsentsPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: search.token as string | undefined,
      uri: search.uri as string | undefined,
      scope: search.scope as string | undefined,
      consentProposalId: search.consentProposalId as string | undefined,
    };
  },
});
